import { ComponentPropsWithoutRef } from 'react';
import { faBookmark as faBookmarkSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Table from 'components/table';

interface SavedForLaterTableEmptyProps extends ComponentPropsWithoutRef<'div'> {}

const SavedForLaterTableEmpty = (props: SavedForLaterTableEmptyProps) => {
    return (
        <Table.Empty {...props}>
            <Table.EmptyIcon>
                <FontAwesomeIcon icon={faBookmarkSolid} />
            </Table.EmptyIcon>
            <Table.EmptyTitle>No saved issues</Table.EmptyTitle>
            <Table.EmptyDescription>
                Toggle the saved button again to see all issues.
            </Table.EmptyDescription>
        </Table.Empty>
    );
};

export { SavedForLaterTableEmpty };
